import { FirebaseApp, FirebaseOptions, getApp, getApps, initializeApp } from 'firebase/app';
import { browserLocalPersistence, getAuth, setPersistence } from 'firebase/auth';

const firebaseConfigByHost: Record<string, FirebaseOptions> = {
  'handoverengine.web.app': {
    apiKey: 'AIzaSyBLF2u-mT7SQMm7J4fimwHlFdcTBh-8Bv4',
    authDomain: 'handoverengine.firebaseapp.com',
    projectId: 'handoverengine',
    storageBucket: 'handoverengine.appspot.com',
    messagingSenderId: '806102199376',
    appId: '1:806102199376:web:4a88fd6ed2a45a69cbf555',
  },
  'handoverengine.firebaseapp.com': {
    apiKey: 'AIzaSyBLF2u-mT7SQMm7J4fimwHlFdcTBh-8Bv4',
    authDomain: 'handoverengine.firebaseapp.com',
    projectId: 'handoverengine',
    storageBucket: 'handoverengine.appspot.com',
    messagingSenderId: '806102199376',
    appId: '1:806102199376:web:4a88fd6ed2a45a69cbf555',
  },
  'handover-test-server.web.app': {
    apiKey: 'AIzaSyCqhbqJ3Z0AIg3cQMVrYif3zIlmSbVE6Pg',
    authDomain: 'handover-test-server.firebaseapp.com',
    projectId: 'handover-test-server',
    storageBucket: 'handover-test-server.firebasestorage.app',
    messagingSenderId: '42066195035',
    appId: '1:42066195035:web:5cd3478589992da863057e',
  },
  'handover-test-server.firebaseapp.com': {
    apiKey: 'AIzaSyCqhbqJ3Z0AIg3cQMVrYif3zIlmSbVE6Pg',
    authDomain: 'handover-test-server.firebaseapp.com',
    projectId: 'handover-test-server',
    storageBucket: 'handover-test-server.firebasestorage.app',
    messagingSenderId: '42066195035',
    appId: '1:42066195035:web:5cd3478589992da863057e',
  },
};

const buildEnvFirebaseConfig = (): FirebaseOptions => ({
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
});

const isCompleteConfig = (config: FirebaseOptions) =>
  Boolean(
    config.apiKey &&
      config.authDomain &&
      config.projectId &&
      config.storageBucket &&
      config.messagingSenderId &&
      config.appId
  );

export const resolveFirebaseWebConfig = (): FirebaseOptions => {
  const envConfig = buildEnvFirebaseConfig();
  if (isCompleteConfig(envConfig)) {
    return envConfig;
  }

  return (
    firebaseConfigByHost[window.location.hostname] ||
    firebaseConfigByHost['handoverengine.web.app']
  );
};

const firebaseConfig = resolveFirebaseWebConfig();

export const firebaseApp: FirebaseApp = getApps().length
  ? getApp()
  : initializeApp(firebaseConfig);

export const firebaseAuth = getAuth(firebaseApp);

void setPersistence(firebaseAuth, browserLocalPersistence);

